import React from 'react'
import PropTypes from 'prop-types'

import { WebinarRoomHeaderComponent } from '../../../../sharedLegacy/components'

const Header = ({ children }) => (
  <WebinarRoomHeaderComponent>
    {children && children}
  </WebinarRoomHeaderComponent>
)

Header.propTypes = {
  children: PropTypes.node,
}

export default Header
